import React from 'react';
import {connect} from 'react-redux';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useResultsTableDimensions, useToggle, useBoolean} from '../../../utils/hooks';
import SMCTable from '../../../components/core/SMCTable/SMCTable';
import {useCommunityResults} from './communityResultsHelper';
import CommunityFilterPane from '../../Filters/CommunityFilterPane';
import CommunityWizard from '../../Wizards/CommunityWizard';
import {communityPermissionsSelector} from '../../../store/selectors/user.selectors';
import {helpContextPageUrl} from '../../../conf/Routes';
import SMCTableActions from '../../../components/core/SMCTableActions/SMCTableActions';
import {CommunityFilterSchema} from '../../../api/DBSchema/Community';
import SMCButton from '../../../components/Simple/SMCButton';
import ButtonsContainerStyles from "../../../pages/EditorPages/ButtonsContainerStyles";


function CommunityResults({
    communityPermissions
}) {
    
    const [tableWidth, tableHeight] = useResultsTableDimensions();
    const [isFilterPaneOpen, toggleFilterPane] = useToggle(false);
    const [isNewObjectWindowOpen, openNewObjectWindow, closeNewObjectWindow] = useBoolean(false);

    const {
        tableContent,
        isFetching,
        isPageLoaded,
        filterObject,
        setFilterObject,
        freeTextSearch,
        fetchNextPage,
        isLastPage,
        columns,
        sortBasis,
        sortDirection,
        setSort,
        columnsState,
        setColumnsState,
        setDefaultColumnsState,
        rowIdSelector,
        selectedObjects,
        setSelectedObjects,
        columnsWidths,
        setColumnsWidths,
        newObjectCallback,
        reloadButtonOnClick,
        deleteButtonOnClick,
        generateTopologyAction
    } = useCommunityResults();
    
    const canDelete = communityPermissions ? communityPermissions.delete : false;
    const canCreate = communityPermissions ? communityPermissions.create : false;
    const buttonsClasses = ButtonsContainerStyles();

    const CommunityActionsMenu = ({ children }) => {
        return (
            <SMCButton 
                 labelClassName={buttonsClasses.labelColor} 
                 variant="ghost" 
                 onClick={generateTopologyAction}>
                     Generate Topology
             </SMCButton>
         );
    };


    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.communityResults}>        
            <div className="DrawResultsDiv">
                <SMCTableActions
                    openNewObjectWindow={openNewObjectWindow}
                    reloadButtonOnClick={reloadButtonOnClick}
                    deleteButtonOnClick={deleteButtonOnClick}
                    toggleFilterPane={toggleFilterPane}
                    canCreate={canCreate}
                    canDelete={canDelete}
                    isFetching={isFetching} 
                    actions={CommunityActionsMenu}
                    tableContent={tableContent}
                    isFilterPaneOpen={isFilterPaneOpen}
                    selectedObjects={selectedObjects}
                    initialSearch={filterObject}
                    onSearchChange={setFilterObject}
                    searchAttribute={CommunityFilterSchema.name}
                    showFilter={false}
                /> 
                <SMCTable
                    columns={columns}
                    columnsState={columnsState}
                    setColumnsState={setColumnsState}
                    setDefaultColumnsState={setDefaultColumnsState}
                    content={tableContent}
                    sortBasis={sortBasis}
                    sortDirection={sortDirection}
                    setSort={setSort}
                    loading={isFetching}
                    onRequestLoadPage={fetchNextPage}
                    isLastPage={isLastPage}
                    width={tableWidth}
                    height={tableHeight}
                    rowIdSelector={rowIdSelector}
                    selectedObjects={selectedObjects}
                    setSelectedObjects={setSelectedObjects}
                    hasCheckAll={true}
                    defaultColumnsWidths={columnsWidths}
                    onEndResizingColumns={setColumnsWidths}
                    isFilterOpen={isFilterPaneOpen}
                    filterElem={
                        <CommunityFilterPane
                            initialFilter={filterObject}
                            onFilterChange={setFilterObject}
                            open={isFilterPaneOpen}
                        />
                    }
                    textToHighlight={freeTextSearch}
                    showEditIcon={false}
                />
                {/* Floating windows */}
                <CommunityWizard
                    isOpen={isNewObjectWindowOpen}
                    onRequestClose={closeNewObjectWindow}
                    onSuccess={newObjectCallback}
                />
            </div>
        </SMCPage>
    );
}

const mapStateToProps = state => ({
    communityPermissions: communityPermissionsSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(CommunityResults);